var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var parseKLV = require('./code/parseKLV');

var groupDevices = require('./code/groupDevices');

var deviceList = require('./code/deviceList');

var streamList = require('./code/streamList');

var keys = require('./code/data/keys');

var timeKLV = require('./code/timeKLV');

var interpretKLV = require('./code/interpretKLV');

var mergeStream = require('./code/mergeStream');

var groupTimes = require('./code/groupTimes');

var smoothSamples = require('./code/smoothSamples');

var processGPS5 = require('./code/processGPS5');

var filterWrongSpeed = require('./code/filterWrongSpeed');

var presetsOpts = require('./code/data/presetsOptions');

var toGpx = require('./code/presets/toGpx');

var toVirb = require('./code/presets/toVirb');

var toKml = require('./code/presets/toKml');

var toGeojson = require('./code/presets/toGeojson');

var toCsv = require('./code/presets/toCsv');

var toMgjson = require('./code/presets/toMgjson');

var mergeInterpretedSources = require('./code/mergeInterpretedSources');

var breathe = require('./code/utils/breathe');

var getOffset = require('./code/utils/getOffset');

var findFirstTimes = require('./code/utils/findFirstTimes');

function parseOne(_x, _x2) {
  return _parseOne.apply(this, arguments);
}

function _parseOne() {
  _parseOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref, opts) {
    var rawData, parsedData, parsed, error;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rawData = _ref.rawData, parsedData = _ref.parsedData;

            if (!parsedData) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", parsedData);

          case 3:
            _context2.next = 5;
            return breathe();

          case 5:
            _context2.next = 7;
            return parseKLV(rawData, opts);

          case 7:
            parsed = _context2.sent;

            if (parsed.DEVC) {
              _context2.next = 16;
              break;
            }

            error = new Error('Invalid GPMF data. Root object must contain DEVC key');

            if (!opts.tolerant) {
              _context2.next = 15;
              break;
            }

            setImmediate(function () {
              return console.error(error);
            });
            return _context2.abrupt("return", parsed);

          case 15:
            throw error;

          case 16:
            return _context2.abrupt("return", parsed);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseOne.apply(this, arguments);
}

function interpretOne(_x3) {
  return _interpretOne.apply(this, arguments);
}

function _interpretOne() {
  _interpretOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var timing, parsed, opts, timeMeta, grouped, key, interpreted, _key, timed, _key2, merged, _key3, _key4;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            timing = _ref2.timing, parsed = _ref2.parsed, opts = _ref2.opts, timeMeta = _ref2.timeMeta;
            _context3.next = 3;
            return groupDevices(parsed);

          case 3:
            grouped = _context3.sent;
            _context3.next = 6;
            return breathe();

          case 6:
            if (!(!opts.ellipsoid || opts.geoidHeight || opts.GPS5Precision != null || opts.GPS5Fix != null)) {
              _context3.next = 15;
              break;
            }

            _context3.t0 = _regeneratorRuntime.keys(grouped);

          case 8:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 15;
              break;
            }

            key = _context3.t1.value;
            _context3.next = 12;
            return processGPS5(grouped[key], opts);

          case 12:
            grouped[key] = _context3.sent;
            _context3.next = 8;
            break;

          case 15:
            interpreted = {}; //Apply scale and matrix transformations

            _context3.t2 = _regeneratorRuntime.keys(grouped);

          case 17:
            if ((_context3.t3 = _context3.t2()).done) {
              _context3.next = 26;
              break;
            }

            _key = _context3.t3.value;
            _context3.next = 21;
            return breathe();

          case 21:
            _context3.next = 23;
            return interpretKLV(grouped[_key], opts);

          case 23:
            interpreted[_key] = _context3.sent;
            _context3.next = 17;
            break;

          case 26:
            timed = {}; //Apply timing (gps and mp4) to every sample

            _context3.t4 = _regeneratorRuntime.keys(interpreted);

          case 28:
            if ((_context3.t5 = _context3.t4()).done) {
              _context3.next = 37;
              break;
            }

            _key2 = _context3.t5.value;
            _context3.next = 32;
            return breathe();

          case 32:
            _context3.next = 34;
            return timeKLV(interpreted[_key2], timing, opts, timeMeta);

          case 34:
            timed[_key2] = _context3.sent;
            _context3.next = 28;
            break;

          case 37:
            //Merge samples in sensor entries
            merged = {};
            _context3.t6 = _regeneratorRuntime.keys(timed);

          case 39:
            if ((_context3.t7 = _context3.t6()).done) {
              _context3.next = 48;
              break;
            }

            _key3 = _context3.t7.value;
            _context3.next = 43;
            return breathe();

          case 43:
            _context3.next = 45;
            return mergeStream(timed[_key3], opts);

          case 45:
            merged[_key3] = _context3.sent;
            _context3.next = 39;
            break;

          case 48:
            if (opts.WrongSpeed != null) {
              for (_key4 in merged) {
                if (merged[_key4].streams.GPS5) {
                  merged[_key4].streams.GPS5.samples = filterWrongSpeed(merged[_key4].streams.GPS5.samples, opts.WrongSpeed);
                }
              }
            }

            return _context3.abrupt("return", merged);

          case 50:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _interpretOne.apply(this, arguments);
}

function progress(options, amount) {
  if (options.progress) options.progress(amount);
}

function process(_x4, _x5) {
  return _process.apply(this, arguments);
}

function _process() {
  _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input, opts) {
    var key, _key5, interpreted, timing, parsed, _parsed, i, oneParsed, interpretedArr, gpsDate, mp4Date, _i, p, _interpreted, offset, timeMeta, dev, stream;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return breathe();

          case 2:
            //Prepare presets
            if (presetsOpts[opts.preset]) {
              opts = _objectSpread(_objectSpread(_objectSpread({}, opts), presetsOpts.general.mandatory), presetsOpts[opts.preset].mandatory); //Only pick the non mandatory options when the user did not specify them

              for (key in presetsOpts.general.preferred) {
                if (opts[key] == null) opts[key] = presetsOpts.general.preferred[key];
              }

              for (_key5 in presetsOpts[opts.preset].preferred) {
                if (opts[_key5] == null) opts[_key5] = presetsOpts[opts.preset].preferred[_key5];
              }
            } //Create filter arrays if user didn't


            if (opts.device && !Array.isArray(opts.device)) opts.device = [opts.device];
            if (opts.stream && !Array.isArray(opts.stream)) opts.stream = [opts.stream];
            // Provide approximate progress updates
            progress(opts, 0.01); //Check if input is array of sources

            if (Array.isArray(input) && input.length === 1) input = input[0];

            if (Array.isArray(input)) {
              _context4.next = 31;
              break;
            }

            if (input.timing) {
              timing = JSON.parse(JSON.stringify(input.timing));
              timing.start = new Date(timing.start);
            }

            _context4.next = 11;
            return breathe();

          case 11:
            _context4.next = 13;
            return parseOne(input, opts);

          case 13:
            parsed = _context4.sent;
            progress(opts, 0.2);
            _context4.next = 17;
            return breathe();

          case 17:
            if (!opts.deviceList) {
              _context4.next = 19;
              break;
            }

            return _context4.abrupt("return", deviceList(parsed));

          case 19:
            if (!opts.streamList) {
              _context4.next = 21;
              break;
            }

            return _context4.abrupt("return", streamList(parsed));

          case 21:
            if (!opts.raw) {
              _context4.next = 23;
              break;
            }

            return _context4.abrupt("return", parsed);

          case 23:
            _context4.next = 25;
            return breathe();

          case 25:
            _context4.next = 27;
            return interpretOne({
              timing: timing,
              parsed: parsed,
              opts: opts
            });

          case 27:
            interpreted = _context4.sent;
            progress(opts, 0.4);
            _context4.next = 82;
            break;

          case 31:
            if (!input.some(function (i) {
              return !i.timing;
            })) {
              _context4.next = 33;
              break;
            }

            throw new Error('per-source timing is necessary in order to merge sources');

          case 33:
            if (input.every(function (i) {
              return i.timing.start.getTime() === input[0].timing.start.getTime();
            })) {
              // Some firmwares produce consecutive files with the same creation date.
              // Try to use GPS time or timestamps to solve this
              input.sort(function (a, b) {
                var foundA = findFirstTimes(a.rawData);
                var foundB = findFirstTimes(b.rawData);
                if (foundA.GPSU && foundB.GPSU) return foundA.GPSU - foundB.GPSU;
                if (foundA.STMP && foundB.STMP) return foundA.STMP - foundB.STMP;
                return 0;
              });
            }

            timing = input.map(function (i) {
              return JSON.parse(JSON.stringify(i.timing));
            });
            timing = timing.map(function (t) {
              return _objectSpread(_objectSpread({}, t), {}, {
                start: new Date(t.start)
              });
            }); //Loop parse all files, with offsets

            _parsed = [];
            i = 0;

          case 38:
            if (!(i < input.length)) {
              _context4.next = 46;
              break;
            }

            _context4.next = 41;
            return parseOne(input[i], opts);

          case 41:
            oneParsed = _context4.sent;

            _parsed.push(oneParsed);

          case 43:
            i++;
            _context4.next = 38;
            break;

          case 46:
            progress(opts, 0.2);
            _context4.next = 49;
            return breathe();

          case 49:
            if (!opts.deviceList) {
              _context4.next = 51;
              break;
            }

            return _context4.abrupt("return", _parsed.map(function (p) {
              return deviceList(p);
            }));

          case 51:
            if (!opts.streamList) {
              _context4.next = 53;
              break;
            }

            return _context4.abrupt("return", _parsed.map(function (p) {
              return streamList(p);
            }));

          case 53:
            if (!opts.raw) {
              _context4.next = 55;
              break;
            }

            return _context4.abrupt("return", _parsed);

          case 55:
            //Interpret all
            interpretedArr = [];
            _i = 0;

          case 57:
            if (!(_i < _parsed.length)) {
              _context4.next = 74;
              break;
            }

            p = _parsed[_i];
            _context4.next = 61;
            return breathe();

          case 61:
            _interpreted = void 0;
            offset = 0;

            if (_i > 0) {
              offset = getOffset({
                interpretedArr: interpretedArr,
                i: _i,
                opts: opts,
                timing: timing
              });
            }

            timeMeta = {
              gpsDate: gpsDate,
              mp4Date: mp4Date,
              offset: offset
            };
            _context4.next = 67;
            return interpretOne({
              timing: timing[_i],
              parsed: p,
              opts: opts,
              timeMeta: timeMeta
            });

          case 67:
            _interpreted = _context4.sent;

            if (!gpsDate && timeMeta.gpsDate) {
              gpsDate = timeMeta.gpsDate;
            }

            if (!mp4Date && timeMeta.mp4Date) {
              mp4Date = timeMeta.mp4Date;
            }

            interpretedArr.push(_interpreted);

          case 71:
            _i++;
            _context4.next = 57;
            break;

          case 74:
            progress(opts, 0.3);
            _context4.next = 77;
            return breathe();

          case 77:
            _context4.next = 79;
            return mergeInterpretedSources(interpretedArr);

          case 79:
            interpreted = _context4.sent;
            progress(opts, 0.4); //Set single timing for rest of outer function

            timing = timing[0];

          case 82:
            _context4.next = 84;
            return breathe();

          case 84:
            //Clean unused streams (namely GPS5 used for timing if cached raw data)
            if (opts.stream && opts.stream.length) {
              for (dev in interpreted) {
                for (stream in interpreted[dev].streams) {
                  if (!opts.stream.includes(stream) && !keys.computedStreams.includes(stream)) {
                    delete interpreted[dev].streams[stream];
                  }
                }
              }
            } //Read framerate to convert groupTimes to number if needed


            if (!(opts.groupTimes === 'frames')) {
              _context4.next = 91;
              break;
            }

            if (!(timing && timing.frameDuration)) {
              _context4.next = 90;
              break;
            }

            opts.groupTimes = timing.frameDuration * 1000;
            _context4.next = 91;
            break;

          case 90:
            throw new Error('Frame rate is needed for your current options');

          case 91:
            _context4.next = 93;
            return breathe();

          case 93:
            if (!opts.smooth) {
              _context4.next = 97;
              break;
            }

            _context4.next = 96;
            return smoothSamples(interpreted, opts);

          case 96:
            interpreted = _context4.sent;

          case 97:
            progress(opts, 0.6);
            _context4.next = 100;
            return breathe();

          case 100:
            if (!opts.groupTimes) {
              _context4.next = 104;
              break;
            }

            _context4.next = 103;
            return groupTimes(interpreted, opts);

          case 103:
            interpreted = _context4.sent;

          case 104:
            //Add framerate to top level
            if (timing && timing.frameDuration != null) interpreted['frames/second'] = 1 / timing.frameDuration;
            progress(opts, 0.9);
            _context4.next = 108;
            return breathe();

          case 108:
            if (!(opts.preset === 'gpx')) {
              _context4.next = 112;
              break;
            }

            _context4.next = 111;
            return toGpx(interpreted, opts);

          case 111:
            return _context4.abrupt("return", _context4.sent);

          case 112:
            if (!(opts.preset === 'virb')) {
              _context4.next = 116;
              break;
            }

            _context4.next = 115;
            return toVirb(interpreted, opts);

          case 115:
            return _context4.abrupt("return", _context4.sent);

          case 116:
            if (!(opts.preset === 'kml')) {
              _context4.next = 120;
              break;
            }

            _context4.next = 119;
            return toKml(interpreted, opts);

          case 119:
            return _context4.abrupt("return", _context4.sent);

          case 120:
            if (!(opts.preset === 'geojson')) {
              _context4.next = 124;
              break;
            }

            _context4.next = 123;
            return toGeojson(interpreted, opts);

          case 123:
            return _context4.abrupt("return", _context4.sent);

          case 124:
            if (!(opts.preset === 'csv')) {
              _context4.next = 128;
              break;
            }

            _context4.next = 127;
            return toCsv(interpreted);

          case 127:
            return _context4.abrupt("return", _context4.sent);

          case 128:
            if (!(opts.preset === 'mgjson')) {
              _context4.next = 132;
              break;
            }

            _context4.next = 131;
            return toMgjson(interpreted, opts);

          case 131:
            return _context4.abrupt("return", _context4.sent);

          case 132:
            progress(opts, 1);
            return _context4.abrupt("return", interpreted);

          case 134:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _process.apply(this, arguments);
}

module.exports = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var options,
        callback,
        result,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            callback = _args.length > 2 ? _args[2] : undefined;
            _context.next = 4;
            return process(input, options);

          case 4:
            result = _context.sent;

            if (callback) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", result);

          case 7:
            callback(result);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x6) {
    return _ref3.apply(this, arguments);
  };
}();